import { render, staticRenderFns } from "./JobHold.vue?vue&type=template&id=06a6ce03&"
import script from "./JobHold.vue?vue&type=script&lang=js&"
export * from "./JobHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports